import { call } from '../../utils/serviceUtils';
import {
  USER_NOTIFICATION_GET,
  USER_NOTIFICATION
  } from '../../config/paths';


export function getUserNotifications() {
  return call.get(USER_NOTIFICATION_GET,
    {

    });
}

export function deleteUserNotificationById(id) {
  return call.delete(USER_NOTIFICATION+'/'+id,
  {
    
  });
}

export function createUserNotification(data) {
  return call.post(USER_NOTIFICATION,data);
}

export function updateUserNotification(id,data) {
  return call.put(USER_NOTIFICATION+'/'+id,data);
}


